import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import _imports_0 from '../images/pdf.png';
var _hoisted_1 = {
  class: "report_box container"
};
var _hoisted_2 = {
  class: "report_time"
};
var _hoisted_3 = {
  class: "report_time_a"
};

var _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "report_time_b_pdf",
  src: _imports_0,
  alt: ""
}, null, -1);

var _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "pdf_version_text"
}, "PDF Version ", -1);

var _hoisted_6 = [_hoisted_4, _hoisted_5];
var _hoisted_7 = ["innerHTML"];

var _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "report_deitial"
}, null, -1);

var _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "report_line"
}, null, -1);

var _hoisted_10 = {
  class: "content_text_box"
};
var _hoisted_11 = ["innerHTML"];

var _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "share_box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "share_line"
})], -1);

var _hoisted_13 = {
  class: "report_article_box"
};

var _hoisted_14 = /*#__PURE__*/_createTextVNode("上一篇：");

var _hoisted_15 = ["innerHTML"];
var _hoisted_16 = {
  key: 1
};

var _hoisted_17 = /*#__PURE__*/_createTextVNode("下一篇：");

var _hoisted_18 = ["innerHTML"];
var _hoisted_19 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_link = _resolveComponent("el-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString($setup.reportsDetail.publishDate), 1), $setup.hasPdfUrl ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "report_time_b",
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.openPdf && $setup.openPdf.apply($setup, arguments);
    })
  }, _hoisted_6)) : _createCommentVNode("", true)]), _createElementVNode("h1", {
    class: "report_title",
    innerHTML: $setup.reportsDetail.title
  }, null, 8, _hoisted_7), _hoisted_8, _hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
    class: "content_text",
    innerHTML: $setup.reportsDetail.content
  }, null, 8, _hoisted_11)]), _hoisted_12, _createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, [_createVNode(_component_el_link, {
    type: "info",
    class: "article_prev",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $setup.getReports($setup.previousReports);
    })
  }, {
    default: _withCtx(function () {
      return [_hoisted_14, $setup.previousReports.title ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        innerHTML: $setup.previousReports.title
      }, null, 8, _hoisted_15)) : (_openBlock(), _createElementBlock("span", _hoisted_16, "暂无更多"))];
    }),
    _: 1
  })]), _createElementVNode("div", null, [_createVNode(_component_el_link, {
    type: "info",
    class: "article_next",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $setup.getReports($setup.nextReports);
    })
  }, {
    default: _withCtx(function () {
      return [_hoisted_17, $setup.nextReports.title ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        innerHTML: $setup.nextReports.title
      }, null, 8, _hoisted_18)) : (_openBlock(), _createElementBlock("span", _hoisted_19, "暂无更多"))];
    }),
    _: 1
  })])])]);
}